import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';
import 'assets/OpenSans/stylesheet.css';
import 'semantic/dist/semantic.css';
import 'App.css';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

LogRocket.init('ril6vc/winno');
setupLogRocketReact(LogRocket);

ReactDOM.render(<App />, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js